import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-table-sortable', 'sortBy', 'Sort by');
